import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-none p-2 m-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-book mr-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "KATEGÓRIE", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-slack mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "FARBY", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-th-large mr-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "PRODUKTY", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-box mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "KRABICE", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chart-pie mr-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "KUSY", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clone mr-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "BALÍKY", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search-plus mr-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "VYHĽADÁVANIE A REZERVÁCIA KUSOV", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar-plus mr-2" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "ŽIADOSTI O REZERVÁCIE", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar-plus mr-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "ŽIADOSTI O PRESTRIEKANIE", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/categories",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/colors",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/products",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/boxies",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/stock-items",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/packages",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/search-items",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _hoisted_15
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/reservation-requests/1",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-stock/reservation-requests/2",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_18,
          _hoisted_19
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ])
  ]))
}